export default __webpack_public_path__ + "static/media/address_image.c446f506.png";